// extracted by mini-css-extract-plugin
export default {"map":"CountryMap_map__Ijkih","energyPriceLevels":"CountryMap_energyPriceLevels__lSqhH"};